export default __webpack_public_path__ + "static/media/kayaking.3ce73d81.svg";